__webpack_require__.p = "/smart-scan/";